// extracted by mini-css-extract-plugin
module.exports = {"horizontal_loader":"style_horizontal_loader__1bz3O","move_right":"style_move_right__3WH9w"};